import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getMyLink() {
    return axios.get(`${API_URL}/catalog/my-link`, { headers: authHeader() });
  },
  getSellerInfo(token) {
    return axios.get(`${API_URL}/catalog/seller/${token}`);
  },
  getProducts(params = {}) {
    const query = new URLSearchParams(params).toString();
    return axios.get(`${API_URL}/catalog/products?${query}`);
  },
  getCategories() {
    return axios.get(`${API_URL}/catalog/categories`);
  },
};
